<!-- START: ATTACHMENT DOWNLOADED LINK -->
@if (nameFiles.length) {
    <div class="col-12" *appHideDownload>
        <p class="card-subtitle me-2">
            <small>{{ title ? title : 'Attach File' }}</small>
        </p>
        <app-file [filesPath]="files" [nameFiles]="nameFiles" />
    </div>
}
<!-- END: ATTACHMENT DOWNLOADED LINK -->
